<template>
    <Modal title="库存明细" v-model="show" :closable="false" :mask-closable="false" @on-visible-change="showModal" width="800px">
        <Table :loading="loading" :columns="columns" :data="storageProductChanges" border>
        </Table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;">
                <Page :page-size="page.pageSize" show-total :total="page.total" :current="page.current" @on-change="changePage"></Page>
            </div>
        </div>
        <div slot="footer">
            <el-button size="small" @click="cancel">取消</el-button>
            <el-button size="small" type="primary" @click="cancel">确定</el-button>
        </div>
    </Modal>
    </Modal>
</template>
<script>
export default {
    name: 'CStorageProduct',
    data() {
        return {

            loading: false,
            modalEdit: false,
            modalLoading: false,
            queryParams: {

            },
            others: {

            },
            storageProductChange: {

            },
            page: {
                total: 0,
                current: 1,
                pageSize: 10
            },
            storageProductChanges: [

            ],
            rules: {},
            columns: [{
                    title: '时间',
                    key: 'createTime',
                    width: 180,
                    align: 'center',
                    render: (h, params) => {
                        var me = this;
                        return h("div", [
                            h("span", { style: {} }, me.long2datetime(params.row.createTime))
                        ]);
                    }
                }, {
                    title: '变更前',
                    key: 'beforeCount',
                    width: 130,
                    align: 'center'
                }, {
                    title: '变更数量',
                    key: 'count',
                    width: 130,
                    align: 'center'
                }, {
                    title: '变更后',
                    key: 'afterCount',
                    width: 130,
                    align: 'center'
                },{
                    title: '备注',
                    key: 'remark',
                    align: 'center'
                } 

            ]
        };
    },
    props: [
        'productId', 'show'
    ],
    mounted: function() {
        this.getList();

    },
    computed: {

    },
    methods: {
        search: function() {
            this.page.current = 1;
            this.page.total = 0;
            this.getList();
        },
        reset: function() {
            this.queryParams = {};
        },
        changePage(current) {
            this.page.current = current;
            this.getList();
        },
        getList: function() {
            var me = this;
            var params = me.queryParams;
            params.current = me.page.current;
            params.pageSize = me.page.pageSize;
            params.productId=me.productId;
            me.loading = true;
            me.$http.post("/ware/product/change/getList.action", params).then(response => {
                var body = response;
                if (body.status == 0) {
                    me.page.total = body.obj.totalCount;
                    me.storageProductChanges = body.obj.list;

                }
                me.loading = false;
            }, response => {
                me.loading = false;
            });
        },
        showModal: function(val) {
            this.getList();
        },
        cancel: function() {
            this.$emit("ok")
        }
    }
}
</script>